import ajax from '../http/ajax'

/**
 * 获取门店首页数据
 * @param {*} params 参数
 * @return 略
 */
export const getStoreHomeInfo = params => {
    return ajax.get('getStoreHomeInfo', params)
}
